import { Contact } from "../../services/contact/entities/contact.interface";
import Vue from "vue";
import { ContactState } from "./states/contact.state.interface";
import contactsService from "../../services/contact/contact";
import { saveAs } from "file-saver";
export default {
  namespaced: true,
  state: {
    contacts: [],
    totalContacts: 0,
  },
  getters: {
    getContacts: (state: ContactState) => state.contacts,
    getTotalContacts: (state: ContactState) => state.totalContacts,
  },
  mutations: {
    setContacts(state: ContactState, contacts: Array<Contact>) {
      Vue.set(state, "contacts", contacts);
    },
    setTotalContacts(state: ContactState, totalContacts: number) {
      Vue.set(state, "totalContacts", totalContacts);
    },
  },
  actions: {
    getContacts: async (context: any, payload: any) => {
      context.commit("setContacts", []);

      await contactsService.getContacts(payload).then((response: any) => {
        context.commit("setTotalContacts", response.data.totalContacts);
        context.commit("setContacts", response.data.contacts);
      });
    },
    createContact: async (context: any, payload: any) => {
      const { created } = (await contactsService.createContact(payload)).data;
      if (created) {
        return created;
      }
      throw new Error();
    },
    deleteContact: async (context: any, payload: any) => {
      return await contactsService.deleteContact(payload.contactID);
    },
    exportContacts: async (context: any, payload: any) => {
      const data = (await contactsService.exportContacts(payload)).data;
      saveAs(data, "contacts.xlsx");
    },
  },
};
